/* tslint:disable */
/* eslint-disable */
/**
 * LPPSWebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { formatDateOnly, mapValues } from '../runtime';
import type { RrpCalculationTypeMapping } from './RrpCalculationTypeMapping';
import {
    RrpCalculationTypeMappingFromJSON,
    RrpCalculationTypeMappingFromJSONTyped,
    RrpCalculationTypeMappingToJSON,
    RrpCalculationTypeMappingToJSONTyped,
} from './RrpCalculationTypeMapping';
import type { SimulationSettingMapping } from './SimulationSettingMapping';
import {
    SimulationSettingMappingFromJSON,
    SimulationSettingMappingFromJSONTyped,
    SimulationSettingMappingToJSON,
    SimulationSettingMappingToJSONTyped,
} from './SimulationSettingMapping';
import type { RmCalculationTypeMapping } from './RmCalculationTypeMapping';
import {
    RmCalculationTypeMappingFromJSON,
    RmCalculationTypeMappingFromJSONTyped,
    RmCalculationTypeMappingToJSON,
    RmCalculationTypeMappingToJSONTyped,
} from './RmCalculationTypeMapping';

/**
 * 
 * @export
 * @interface GetCalculationSettingsUploadTargetsResponse
 */
export interface GetCalculationSettingsUploadTargetsResponse {
    /**
     * 
     * @type {Array<RmCalculationTypeMapping>}
     * @memberof GetCalculationSettingsUploadTargetsResponse
     */
    rmCalculationTypes: Array<RmCalculationTypeMapping> | null;
    /**
     * 
     * @type {Array<RrpCalculationTypeMapping>}
     * @memberof GetCalculationSettingsUploadTargetsResponse
     */
    rrpCalculationTypes: Array<RrpCalculationTypeMapping> | null;
    /**
     * 
     * @type {Array<SimulationSettingMapping>}
     * @memberof GetCalculationSettingsUploadTargetsResponse
     */
    simulationSettings: Array<SimulationSettingMapping> | null;
}

/**
 * Check if a given object implements the GetCalculationSettingsUploadTargetsResponse interface.
 */
export function instanceOfGetCalculationSettingsUploadTargetsResponse(value: object): value is GetCalculationSettingsUploadTargetsResponse {
    if (!('rmCalculationTypes' in value) || value['rmCalculationTypes'] === undefined) return false;
    if (!('rrpCalculationTypes' in value) || value['rrpCalculationTypes'] === undefined) return false;
    if (!('simulationSettings' in value) || value['simulationSettings'] === undefined) return false;
    return true;
}

export function GetCalculationSettingsUploadTargetsResponseFromJSON(json: any): GetCalculationSettingsUploadTargetsResponse {
    return GetCalculationSettingsUploadTargetsResponseFromJSONTyped(json, false);
}

export function GetCalculationSettingsUploadTargetsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCalculationSettingsUploadTargetsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'rmCalculationTypes': (json['rmCalculationTypes'] == null ? null : (json['rmCalculationTypes'] as Array<any>).map(RmCalculationTypeMappingFromJSON)),
        'rrpCalculationTypes': (json['rrpCalculationTypes'] == null ? null : (json['rrpCalculationTypes'] as Array<any>).map(RrpCalculationTypeMappingFromJSON)),
        'simulationSettings': (json['simulationSettings'] == null ? null : (json['simulationSettings'] as Array<any>).map(SimulationSettingMappingFromJSON)),
    };
}

export function GetCalculationSettingsUploadTargetsResponseToJSON(json: any): GetCalculationSettingsUploadTargetsResponse {
    return GetCalculationSettingsUploadTargetsResponseToJSONTyped(json, false);
}

export function GetCalculationSettingsUploadTargetsResponseToJSONTyped(value?: GetCalculationSettingsUploadTargetsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'rmCalculationTypes': (value['rmCalculationTypes'] == null ? null : (value['rmCalculationTypes'] as Array<any>).map(RmCalculationTypeMappingToJSON)),
        'rrpCalculationTypes': (value['rrpCalculationTypes'] == null ? null : (value['rrpCalculationTypes'] as Array<any>).map(RrpCalculationTypeMappingToJSON)),
        'simulationSettings': (value['simulationSettings'] == null ? null : (value['simulationSettings'] as Array<any>).map(SimulationSettingMappingToJSON)),
    };
}

